module.exports = {"440104001":"洪桥街道","440104003":"北京街道","440104004":"六榕街道","440104005":"流花街道","440104007":"光塔街道","440104010":"人民街道","440104011":"东山街道","440104012":"农林街道","440104013":"梅花村街道","440104014":"黄花岗街道","440104015":"华乐街道","440104016":"建设街道","440104017":"大塘街道","440104018":"珠光街道","440104019":"大东街道","440104020":"白云街道","440104021":"登峰街道","440104022":"矿泉街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440104.json
// module id = 1775
// module chunks = 0